<template>
  <div :class="$style.priceWrapper">
    <div v-for="platformPrice in PRICES" :key="platformPrice" :class="$style.priceCol">
      <VdIcon
        store="fas"
        :name="getIconName(selectedPriceType)"
        color="var(--vd-color-text-light-2)"
        :style="{ marginRight: '0.5rem' }"
      />
      <div
        v-if="selectedPriceType === 'IN_GAME_CURRENCY' && offerProduct[platformPrice].inGamePrice?.item"
        :class="$style.rewardItemsWrapper"
      >
        <div :class="$style.rewardItem">
          <PriceItemWithQuantity
            v-if="offerProduct[platformPrice].inGamePrice?.item"
            :store-item="offerProduct[platformPrice].inGamePrice.item"
            :price-amount="offerProduct[platformPrice].inGamePrice.quantity"
          />
        </div>
      </div>

      <div v-else-if="selectedPriceType === 'IAP'">
        <div :class="$style.priceTd">
          <div>
            {{ offerProduct[platformPrice].IAP?.pricing?.[0]?.value }}
            {{ offerProduct[platformPrice].IAP?.pricing?.[0]?.currency }}
          </div>
          <div :class="$style.iapProductId">{{ offerProduct[platformPrice].IAP?.productId }}</div>
        </div>
      </div>

      <div v-else-if="selectedPriceType === 'RV'">
        <div :class="$style.priceCol">{{ offerProduct[platformPrice].rvQuantity }}</div>
      </div>

      <span v-else-if="selectedPriceType === 'FREE'" :class="$style.priceTd">
        <div :class="$style.priceCol">Free</div>
      </span>
    </div>
    <VdIcon store="fa" name="chevron-down" size="small" color="var(--vd-color-text-light-2)"></VdIcon>
  </div>
</template>

<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { OfferProduct } from "@/graphql";
import { PropType } from "vue";
import PriceItemWithQuantity from "../PriceItemWithQuantity.vue";

interface KeyString {
  [key: string]: any;
}

const props = defineProps({
  offerProduct: {
    type: Object as PropType<OfferProduct & KeyString>,
    required: true,
  },
  selectedPriceType: {
    type: String,
    required: true,
  },
  isPayLater: {
    type: Boolean,
    default: false,
  },
});

const PRICES = props.isPayLater ? ["reRollIosPrice", "reRollAndroidPrice"] : ["iosPrice", "androidPrice"];

const getIconName = (name: string) => {
  switch (name) {
    case "IAP":
      return "money-bill";
    case "IN_GAME_CURRENCY":
    case "FREE":
      return "box";
    case "RV":
      return "clapperboard-play";
    default:
      return "";
  }
};
</script>

<style module lang="scss">
.priceWrapper {
  width: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  .priceCol {
    display: flex;
    align-items: center;
    flex: 1;
    width: 50%;
  }

  svg {
    color: var(--vd-color-text-light-2);
  }
}

.rewardItemsWrapper {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.rewardItem {
  display: flex;
  align-items: center;
}

.priceTd {
  flex: 1;
  margin-left: 0.5rem;

  .iapProductId {
    color: var(--vd-color-text-light-2);
    font-size: 12px;
  }
}
</style>
